<template>
    <div>
        <div class='card mb-5 shadow'>
            <div class='card-header'>
                API CADOR
                <year-handler
                    @update-data='getAccountingFirmCompanies'
                ></year-handler>
            </div>
            <div class='card-body'>
                <div v-if='loading'>
                    <loading></loading>
                </div>
                <div v-else>
                    <b-table :items='items' :fields='fields'>
                        <template #cell(last_cador_updated_at)='data'>
                            <div v-if="!data.item.error_api">
                                <span>{{ data.item.last_cador_updated_at }}</span>
                                <b-button
                                    v-if='data.item.update_logs !== null'
                                    v-b-modal.modal-scrollable
                                    size='sm'
                                    class='ml-3'
                                    variant='light'
                                    @click='displayUpdateInfos(data.item)'
                                >
                                    <span>Voir les écritures non importées</span>
                                    <i class='fas fa-arrow-down ml-2'></i>
                                </b-button>
                            </div>
                            <div v-else>
                                <span class='text-danger'>Erreur API : {{data.item.update_logs}}</span>
                            </div>
                        </template>
                        <template #cell(id)='row'>
                            <update-handler
                                :accounting-firm-company-id='row.item.id'
                                :year='year'
                                @accounting-firm-company-updated='
                                    getAccountingFirmCompanies
                                '
                            />
                        </template>
                    </b-table>
                </div>
            </div>
        </div>
        <div class='card mb-5 shadow'>
            <error-logs-table
                :title-table='titleUpdateLogs'
                :update-logs='updateLogs'
                :has-log='hasLog'
                :total-amount='totalAmount'
            />
        </div>
    </div>
</template>

<script>
import { mapState } from 'vuex'
import ToastHandler from '../../../common/mixins/ToastHandler.vue'
import YearHandler from '../../../activity_management/activity/components/YearHandler.vue'
import UpdateHandler from '../../components/UpdateHandler.vue'
import ErrorLogsTable from '../../components/ErrorLogsTable.vue'

export default {
    name: 'CadorUpdate',

    components: { ErrorLogsTable, UpdateHandler, YearHandler },

    mixins: [ToastHandler],

    data() {
        return {
            loading: false,
            items: [],
            updateLogs: [],
            totalAmount: 0,
            titleUpdateLogs: '',
            hasLog: false,
            fields: [
                {
                    key: 'name',
                    label: 'Cabinet'
                },
                {
                    key: 'last_cador_updated_at',
                    label: 'Dernière mise à jour'
                },

                {
                    key: 'id',
                    label: 'Action',
                    class: 'text-right'
                }
            ]
        }
    },
    async created() {
        this.loading = true
        await this.getAccountingFirmCompanies()
        this.loading = false
    },

    methods: {
        async getAccountingFirmCompanies() {
            try {
                const response = await this.$axios.get(`cador/afc/${this.year}`)
                this.items = response.data.data
                // eslint-disable-next-line no-param-reassign
                this.items.forEach((el) => (el.showProgress = false))
            } catch (e) {
                this.showErrorToast(e)
            }
        },
        displayUpdateInfos(item) {
            this.titleUpdateLogs = `${item.name} - ${this.year}`
            this.updateLogs = item.update_logs
            this.totalAmount = item.total_amount_logs
            this.hasLog = true
        }
    },

    computed: {
        ...mapState({
            year: (state) => state.browsing.year
        })
    }
}
</script>

<style scoped></style>
